var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.233812 12.3299L5.78645 6.89734L0.233812 1.43475C-0.516545 0.714403 0.71404 -0.516181 1.4644 0.234176L7.7974 6.3871C8.06753 6.65723 8.06753 7.10744 7.7974 7.34755L1.4644 13.5605C0.71404 14.2808 -0.516545 13.0503 0.233812 12.3299Z",
    fill: "#5F6163"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.b874ff4d84584c119033ea01cd6d1ab9.svg";
export { ForwardRef as ReactComponent };